import React from 'react';
import { getCurrentUser } from '../lib/auth';
import DashboardCatalogue from '../components/DashboardCatalogue';

const AdminCatalogue = () => {
  const user = getCurrentUser();

  if (!user) {
    return null;
  }

  return <DashboardCatalogue user={user} />;
};

export default AdminCatalogue;